import 'src/resources/styles/preloading.scss';
import '@babel/polyfill';

import packageJson from '../../package.json';

// eslint-disable-next-line no-console
console.info(`${packageJson?.name} %c${packageJson?.version}`, 'color: #E7C696');

import('./app');
